<template>
    <div class="tw-grid tw-gap-4 xl:tw-gap-12 tw-auto-rows-max tw-grid-cols-1 xl:tw-grid-cols-3">
        <l-meeting-analytics-totals-box
            v-for="type in types"
            :key="type"
            :icon="
                type === 'meetingTotals'
                    ? 'fa-comment-smile'
                    : type === 'meetingGroupTotals'
                    ? 'fa-users-class'
                    : 'fa-analytics'
            "
        >
            <template #title>
                {{ $t(`meetings.analytics.totals.${type}`) }}
            </template>
            <template #number>
                <template v-if="type === 'meetingTotals'">
                    {{ analytics[type].amountTotal }}x
                </template>
                <template v-else-if="type === 'meetingGroupTotals'">
                    {{ analytics[type].amountTotalGroups }}
                </template>
                <template v-else>
                    {{ analytics[type].averageDurationInMinutes }}
                </template>
            </template>

            <i18n
                v-if="analytics[type]"
                :path="`meetings.analytics.totals.${type}Inner`"
                for="value"
            >
                <span class="tw-text-indigo-500 tw-text-lg tw-leading-none tw-font-bold">
                    {{ getSingleValue(type) }}
                </span>
            </i18n>
        </l-meeting-analytics-totals-box>
    </div>
</template>

<script>
import LMeetingAnalyticsTotalsBox from "@/components/LMeetingAnalytics/LMeetingAnalyticsTotalsBox";

export default {
    components: {
        LMeetingAnalyticsTotalsBox,
    },
    props: {
        analytics: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            types: ["meetingTotals", "meetingGroupTotals", "meetingStats"],
        };
    },
    methods: {
        getSingleValue(type) {
            switch (type) {
                case "meetingTotals":
                    return this.analytics?.[type]?.amountLikelyHeld || 0;
                case "meetingGroupTotals":
                    return this.analytics?.[type]?.amountTotalParticipants || 0;
                case "meetingStats":
                default:
                    return this.analytics?.[type]?.averageAmountOfParticipants || 0;
            }
        },
    },
};
</script>
